<template>
  <el-form
    :label-position="labelPosition"
    :label-width="labelWidth"
    :inline="inline"
    class="filter_con"
    :class="{
      filterUp: filterState,
    }"
  >
    <customize-form
      :formConfig="formConfig"
      :form="form"
      class="filter-form"
      ref="filterForm"
    ></customize-form>
    <slot name="footer"></slot>
    <el-button
      v-show="showOperate"
      type="text"
      class="filter__operate"
      @click="toggleFilterState"
      >{{ filterState ? "展开" : "收缩" }}
      <i
        :class="{
          'el-icon-arrow-up': !filterState,
          'el-icon-arrow-down': filterState,
        }"
      ></i
    ></el-button>
  </el-form>
</template>

<script>
import CustomizeForm from "@/components/customize-form";
export default {
  props: {
    labelPosition: {
      type: String,
      default: "right",
    },
    labelWidth: {
      type: String,
    },
    formConfig: Array,
    form: Object,
    inline: {
      type: Boolean,
      default: false,
    },
    hideOperate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filterState: false,
      showOperate: true,
    };
  },
  mounted() {
    const heigth = this.$refs.filterForm.$el.offsetHeight;
    if (heigth > 60) {
      this.filterState = true;
    } else {
      this.filterState = false;
      this.showOperate = false;
    }
    if (this.hideOperate) {
      this.showOperate = false;
      this.filterState = false;
    }
  },
  components: {
    CustomizeForm,
  },
  methods: {
    toggleFilterState() {
      this.filterState = !this.filterState;
      this.$emit("collapse-change");
    },
  },
};
</script>

<style lang="scss">
.filter_con {
  position: relative;
  .filter-form {
    .form-row {
      display: flex;
      flex-wrap: wrap;
    }
  }
  &.filterUp {
    .filter-form {
      height: 50px;
      overflow: hidden;
    }
  }
  .filter__operate {
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    &::after {
      display: none;
    }
    i {
      font-size: 16px;
    }
  }
  .el-input {
    width: 80%;
  }
  .el-select {
    .el-input {
      width: 100%;
    }
  }
  .el-form-item.flex-form-item {
    display: flex !important;
    white-space: nowrap;
    .el-form-item__content > .el-input {
      width: 30%;
      margin-left: 5px;
    }
  }
  .el-form-item__label {
    color: #17181a;
    white-space: nowrap;
    font-weight: normal;
    font-size: 16px;
  }
  button {
    margin-bottom: 20px;
  }
}

@media only screen and (max-width: 1200px) {
  .filter-form {
    .el-form-item__label {
      font-size: 14px;
    }
  }
}
</style>
